import React, { useEffect, useState } from "react";
import { View, ScrollView, Text } from "react-native";
import { TextInput, Button, RadioButton, ActivityIndicator, ThemeProvider, DefaultTheme, Checkbox } from "react-native-paper";
import { connect } from "react-redux";
import globalStyles from "../../app/components/Styles";
import { Divider } from '@rneui/themed';
import { editMatch } from "../../app/store/actions/adminActions";
import moment from "moment";
import { useNavigation } from "@react-navigation/native";
import { DatePickerInput, TimePickerModal } from "react-native-paper-dates";
import { getTournament } from "../../app/store/actions/userActions";
import DropDown from "react-native-paper-dropdown";
import AppBar from "../../AppBar";
import ColorPicker from "react-native-wheel-color-picker";

const EditMatch = ({ editMatch, getTournament, isLoading, teams, route, defaults, fullTournament }) => {
    const { tournament, match } = route.params;

    const [stage, setStage] = useState(fullTournament?.type === "Knockout" ? "Knockout Match" : (fullTournament?.type === "League" ? "Group Match" : undefined));
    const [round, setRound] = useState(undefined);
    const [date, setDate] = useState(defaults?.date ? new Date(defaults?.date) : new Date());
    const [livestream, setLivestream] = useState("");
    const [time, setTime] = useState({ hours: match ? moment(match.date).add(-3, "hours").hours() : 18, minutes: match ? moment(match.date).minutes() : 0 });
    const [duration, setDuration] = useState(`${match.duration}`);
    const [visible, setVisible] = React.useState(false);
    const [shirtColors, setShirtColors] = useState(match.teamAColor !== undefined)
    const [teamAColor, setTeamAColor] = useState(match ? match.teamAColor : "")
    const [teamBColor, setTeamBColor] = useState(match ? match.teamBColor : "")
    const [showDropDown3, setShowDropDown3] = useState(false);
    const [showDropDown4, setShowDropDown4] = useState(false);


    const onDismiss = React.useCallback(() => {
        setVisible(false)
    }, [setVisible])

    const onConfirm = React.useCallback(
        ({ hours, minutes }) => {
            setVisible(false);
            setTime({ hours, minutes });
        },
        [setVisible]
    );

    const navigation = useNavigation();

    useEffect(() => {
        getTournament({ tournamentId: (match ? tournament : tournament._id) });
        console.log(time)
    }, [])

    const handleEditMatch = () => {
        console.log(time)
        const edits = {
            date: moment(date).startOf("day").add(time.hours, "hours").add(time.minutes, "minutes").format("MM-DD-YYYY HH:mm"),
            teamAColor: shirtColors ? teamAColor : undefined,
            teamBColor: shirtColors ? teamBColor : undefined,
            stage,
            round,
            duration,
            livestream
        }
        console.log(edits)
        editMatch({ edits, matchId: match._id }, navigation)
    };

    const onSelectColorA = (item) => {
        setTeamAColor(item)
    };

    const onSelectColorB = (item) => {
        setTeamBColor(item)
    };

    if (isLoading) {
        return (
            <View style={globalStyles.container}>
                <ActivityIndicator />
            </View>
        )
    }

    return (
        <ScrollView>
            <AppBar navigation={navigation} title={fullTournament?.name} />
            <View style={{ padding: 30 }} contentContainerStyle={{ justifyContent: "center" }}>
                {fullTournament?.type === "Group-Knockout" && <DropDown
                    dropDownItemTextStyle={{ color: "whitesmoke" }}
                    dropDownItemSelectedTextStyle={{ fontWeight: "bold", color: "white" }}
                    style={globalStyles.input}
                    label={"Match Stage"}
                    mode={"outlined"}
                    visible={showDropDown3}
                    showDropDown={() => setShowDropDown3(true)}
                    onDismiss={() => setShowDropDown3(false)}
                    value={stage}
                    setValue={setStage}
                    list={[
                        { label: "Group", value: "Group Match" },
                        { label: "Knockout", value: "Knockout Match" },
                    ]}
                />}

                {stage === "Knockout Match" && <DropDown
                    dropDownItemTextStyle={{ color: "whitesmoke" }}
                    dropDownItemSelectedTextStyle={{ fontWeight: "bold", color: "white" }}
                    style={globalStyles.input}
                    label={"Knockout Stage"}
                    mode={"outlined"}
                    visible={showDropDown4}
                    showDropDown={() => setShowDropDown4(true)}
                    onDismiss={() => setShowDropDown4(false)}
                    value={round}
                    setValue={setRound}
                    list={[
                        { label: "Round of 64", value: "Round of 64" },
                        { label: "Round of 32", value: "Round of 32" },
                        { label: "Round of 16", value: "Round of 16" },
                        { label: "Quarter Final", value: "Quarter Final" },
                        { label: "Semi Final", value: "Semi Final" },
                        { label: "Final", value: "Final" },
                    ]}
                />}

                <Text style={{ fontSize: 25, fontWeight: "bold", textAlign: "center", marginBottom: 20 }}>{match.teamA.name} VS {match.teamB.name}</Text>
                {shirtColors && <View style={{ justifyContent: "center", alignItems: "center" }}>
                    <Text style={{ fontSize: 15, fontWeight: "bold", textAlign: "center", marginBottom: 5 }}>{match.teamA.name}</Text>
                    <ColorPicker color={teamAColor} onColorChangeComplete={onSelectColorA} thumbSize={15} sliderHidden={true} swatches={true} />
                </View>}
                {shirtColors && <View style={{ justifyContent: "center", alignItems: "center" }}>
                    <Text style={{ fontSize: 15, fontWeight: "bold", textAlign: "center", marginBottom: 5 }}>{match.teamB.name}</Text>
                    <ColorPicker color={teamBColor} onColorChangeComplete={onSelectColorB} thumbSize={15} sliderHidden={true} swatches={true} />
                </View>}
                <Divider style={{ marginTop: 5 }} />
                <Checkbox.Item label="Set Shirt Colors" onPress={() => { setShirtColors(!shirtColors); }} status={shirtColors ? "checked" : "unchecked"} />
                <Divider style={{ marginBottom: 5 }} />
                <ThemeProvider theme={{
                    ...DefaultTheme,
                    colors: {
                        ...DefaultTheme.colors,
                        primary: '#000B26',
                        onPrimary: "#ffffff",
                        surface: '#ffffff',
                    }
                }}>
                    <DatePickerInput
                        locale="en-GB"
                        mode="outlined"
                        style={{ marginTop: 8 }}
                        label="Date"
                        value={date}
                        onChange={(d) => setDate(d)}
                        inputMode="start"
                    />
                </ThemeProvider>

                <Button style={{ marginVertical: 8 }} onPress={() => setVisible(true)} uppercase={false} mode="outlined">
                    Pick time
                </Button>

                <ThemeProvider theme={{
                    ...DefaultTheme,
                    colors: {
                        ...DefaultTheme.colors,
                        primary: '#ffffff',
                        onPrimary: "#000B26",
                        onBackground: '#000B26',
                        secondaryContainer: '#ffffff',
                        onSecondary: "#000B26",
                        surface: '#000B26',
                        onSurfaceVariant: "#ffffff"
                    }
                }}>
                    <TimePickerModal
                        locale="en-GB"
                        visible={visible}
                        onDismiss={onDismiss}
                        onConfirm={onConfirm}
                        hours={time.hours}
                        minutes={time.minutes}
                    />
                </ThemeProvider>

                <TextInput
                    mode="outlined"
                    label="Duration"
                    value={duration}
                    keyboardType="numeric"
                    onChangeText={(text) => setDuration(text)}
                />
                <TextInput
                    mode="outlined"
                    label="Livestream URL"
                    value={livestream}
                    onChangeText={(text) => setLivestream(text)}
                />
                <Button style={{ marginTop: 8 }} mode="contained" onPress={handleEditMatch}>
                    Edit Match
                </Button>
            </View>
        </ScrollView>
    );
}
const mapStateToProps = (state) => ({
    isLoading: state?.records?.isLoading,
    teams: state?.records?.teams,
    defaults: state?.records?.tournament?.matchDefaults,
    fullTournament: state?.records?.tournament
});

const mapDispatchToProps = {
    editMatch,
    getTournament
};

export default connect(mapStateToProps, mapDispatchToProps)(EditMatch);